import {
  Button,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Autocomplete,
  Modal,
  Box,
  Select,
  MenuItem,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import nopdf from "../../../assets/images/nopdf.png";

import { toast } from "react-toastify";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "180vh",
  height: "85vh",
  bgcolor: "#f5f5f5",
  border: "1px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: 10,
};

type Props = {};

const DocPagesEdit = (props: Props) => {
  const location = useLocation();
  console.log("location", location.state);

  const { t } = useTranslation();


  //   const [PdfOption, setPdfOption] = useState<any>([
  //     { value: "-1", label: "SelectPdf" },
  //   ]);

  //   const [Option, setOption] = useState<any>([
  //     { value: "-1", label: "SelectChildPdf" },
  //   ]);
  const [TypeOption, setTypeOption] = useState<any>([
    { value: "-1", label: t("text.SelectFileName") },
  ]);

  useEffect(() => {
    // getPdf();
    // getChiPdf();
    getFile();
  }, []);

  //   const getPdf = () => {
  //     const collectData = {
  //       fileTypeId: -1,
  //     };
  //     axios
  //       .post(HOST_URL.HOST_URL2 + `FileType/GetFileType`, collectData)
  //       .then((res) => {
  //         const arr = res.data.data.map((item: any) => ({
  //           label: item.fileTypeName,
  //           value: item.fileTypeId,
  //         }));
  //         setPdfOption(arr);
  //       });
  //   };

  //   const getChiPdf = () => {
  //     const collectData = {
  //       fileTypeId: -1,
  //     };
  //     axios
  //       .post(HOST_URL.HOST_URL2 + `FileType/GetFileType`, collectData)
  //       .then((res) => {
  //         const arr = res.data.data.map((item: any) => ({
  //           label: item.fileTypeName,
  //           value: item.fileTypeId,
  //         }));
  //         setOption(arr);
  //       });
  //   };

  const getFile = () => {
    const collectData = {
      pdfName: -1,
      pdFid: -1,
    };
    axios
      .post(HOST_URL.HOST_URL2 + `DocFiles/GetDocFiles`, collectData)
      .then((res) => {
        const arr = res.data.data.map((item: any) => ({
          label: item.pdfName,
          value: item.pdFid,
        }));
        setTypeOption(arr);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  let navigate = useNavigate();

  const back = useNavigate();

  const requiredFields = ["fileName"];

  const validationSchema = Yup.object({
    fileName: Yup.string().test(
      "required",

      function (value: any) {
        return value && value.trim() !== "";
      }
    ),
  });

  const formik = useFormik({
    initialValues: {
      dPgid: location.state.dPgid,
      fileName: location.state.fileName,
      pdFid: location.state.pdFid,
      pgNF: location.state.pgNF,
      pgNU: location.state.pgNU,
      comments: location.state.comments,
      createdate: location.state.createdate,
      chiPDFid: location.state.chiPDFid,
      phySNo: location.state.phySNo,
      phyIndex: location.state.phyIndex,
      relOfficer: location.state.relOfficer,
      createdateNew: location.state.createdateNew,
      user_Id: location.state.user_Id,
      userId: location.state.userId,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      var collection = {
        docFPages: [values],
      };
      console.log(collection);
      const response = await axios.post(
        HOST_URL.HOST_URL2 + `DocFPages/AddUpdateDocFPages`,
        collection
      );
      try {

        toast.success(response.data.mesg);
        navigate("/DocManagement/DocPages");
      } catch (error) {


        toast.error(response.data.mesg);
      }
    },
  });

  return (
    <div>
      <div
        style={{
          padding: "-5px 5px",
          backgroundColor: "#ffffff",
          borderRadius: "5px",
          marginTop: "5px",
          border: ".5px solid #FF7722",
        }}
      >
        <CardContent>
          <Typography
            variant="h5"
            textAlign="center"
            style={{ fontSize: "18px", fontWeight: 500 }}
          >
           {t("text.EditDocPages")}
          </Typography>

          <Grid item sm={4} xs={12}>
            <Typography style={{ marginTop: "-75px" }}>
              <Button
                type="submit"
                onClick={() => back(-1)}
                variant="contained"
                style={{
                  marginBottom: 15,
                  marginTop: "45px",
                  backgroundColor:`var(--header-background)`,
                  width: 20,
                }}
              >
                <ArrowBackSharpIcon />
              </Button>
            </Typography>
          </Grid>
          <Divider />
          <br />
          <form onSubmit={formik.handleSubmit}>
            <Grid item xs={12} container spacing={2}>
              <Grid md={4} item>
                <Autocomplete
                  disablePortal
                  options={TypeOption}
                  id="fileName"
                  fullWidth
                  size="small"
                  value={formik.values.fileName}
                  // value={
                  //   TypeOption.find(
                  //     (opt: any) => opt.value === formik.values.fileName
                  //   ) || null
                  // }
                  onChange={(event, newValue: any) => {
                    console.log(newValue?.label);

                    formik.setFieldValue("fileName", newValue?.label);

                    formik.setFieldTouched("fileName", true);
                    formik.setFieldTouched("fileName", false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          {t("text.SelectFileName")} {""}
                          {requiredFields.includes("fileName") && (
                            <span
                              style={{
                                color: formik.values.fileName ? "green" : "red",
                              }}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                            >
                              *
                            </span>
                          )}
                        </span>
                      }
                    />
                  )}
                />

                {formik.touched.fileName && formik.errors.fileName ? (
                  <div style={{ color: "red", margin: "5px" }}>
                    {String(formik.errors.fileName)}
                  </div>
                ) : null}
              </Grid>

              <Grid md={4} item>
                <TextField
                  label={t("text.PageNoFrom")}
                  value={formik.values.pgNF}
                  placeholder={t("text.PageNoFrom")}
                  size="small"
                  fullWidth
                  name="pgNF"
                  id="pgNF"
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              <Grid md={4} item>
                <TextField
                  label={t("text.PageNoUpto")}
                  value={formik.values.pgNU}
                  placeholder={t("text.PageNoUpto")}
                  size="small"
                  fullWidth
                  name="pgNU"
                  id="pgNU"
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              <Grid md={4} item>
                <TextField
                  label={t("text.Comments")}
                  value={formik.values.comments}
                  name="comments"
                  id="comments"
                  placeholder={t("text.Comments")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              {/* <Grid md={4} item>
                  <TextField
                    label="Created Date"
                    value={formik.values.createdate}
                    placeholder="Created Date"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    name="createdate"
                    id="createdate"
                    type="date"
                    style={{ backgroundColor: "white" }}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </Grid>
  
                <Grid md={4} item>
                  <TextField
                    label="Created Date New"
                    value={formik.values.createdateNew}
                    placeholder="Created  Date New"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    name="createdateNew"
                    id="createdateNew"
                    type="date"
                    style={{ backgroundColor: "white" }}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </Grid> */}

              <Grid md={4} item>
                <TextField
                  label={t("text.PhysicalSerialNo")}
                  value={formik.values.phySNo}
                  name="phySNo"
                  id="phySNo"
                  placeholder={t("text.PhysicalSerialNo")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              <Grid md={4} item>
                <TextField
                  label={t("text.PhysicalIndex")}
                  value={formik.values.phyIndex}
                  name="phyIndex"
                  id="phyIndex"
                  placeholder={t("text.PhysicalIndex")}
                  size="small"
                  fullWidth
                  style={{ backgroundColor: "white" }}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
              </Grid>

              {/* <Grid md={4} item>
                  <TextField
                    label="Related Officer"
                    value={formik.values.relOfficer}
                    name="relOfficer"
                    id="relOfficer"
                    placeholder="relOfficer"
                    size="small"
                    fullWidth
                    style={{ backgroundColor: "white" }}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </Grid>
  
                <Grid item lg={4} xs={12}>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={PdfOption}
                    value={
                      PdfOption.find(
                        (option: any) => option.value === formik.values.pdFid
                      ) || null
                    }
                    fullWidth
                    size="small"
                    onChange={(event, newValue: any) => {
                      console.log(newValue?.value);
  
                      formik.setFieldValue("pdFid", newValue?.value);
  
                      formik.setFieldTouched("pdFid", true);
                      formik.setFieldTouched("pdFid", false);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          <span>
                            Select Pdf {""}
                            {requiredFields.includes("pdFid") && (
                              <span
                                style={{
                                  color: formik.values.pdFid ? "green" : "red",
                                }}
                              >
                                *
                              </span>
                            )}
                          </span>
                        }
                      />
                    )}
                  />
  
                  {formik.touched.pdFid && formik.errors.pdFid ? (
                    <div style={{ color: "red", margin: "5px" }}>
                      {String(formik.errors.pdFid)}
                    </div>
                  ) : null}
                </Grid>
  
                <Grid item lg={4} xs={12}>
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={Option}
                    value={
                      Option.find(
                        (option: any) => option.value === formik.values.chiPDFid
                      ) || null
                    }
                    fullWidth
                    size="small"
                    onChange={(event, newValue: any) => {
                      console.log(newValue?.value);
  
                      formik.setFieldValue("chiPDFid", newValue?.value);
  
                      formik.setFieldTouched("chiPDFid", true);
                      formik.setFieldTouched("chiPDFid", false);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label={
                          <span>
                            Select Child Pdf {""}
                            {requiredFields.includes("chiPDFid") && (
                              <span
                                style={{
                                  color: formik.values.chiPDFid ? "green" : "red",
                                }}
                              >
                                *
                              </span>
                            )}
                          </span>
                        }
                      />
                    )}
                  />
  
                  {formik.touched.chiPDFid && formik.errors.chiPDFid ? (
                    <div style={{ color: "red", margin: "5px" }}>
                      {String(formik.errors.chiPDFid)}
                    </div>
                  ) : null}
                </Grid> */}

              <Grid
                item
                xs={12}
                spacing={2}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <Grid xs={6} style={{ margin: "6px" }}>
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor:`var(--header-background)`,
                      color: "white",
                      marginTop: "10px",
                    }}
                  >
                    {t("text.update")}
                  </Button>
                </Grid>

                <Grid xs={6} style={{ margin: "6px" }}>
                  <Button
                    type="reset"
                    fullWidth
                    style={{
                      backgroundColor: "#F43F5E",
                      color: "white",
                      marginTop: "10px",
                    }}
                    onClick={(e) => formik.resetForm()}
                  >
                    {t("text.reset")}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            {/* </Card> */}
          </form>
        </CardContent>
      </div>
    </div>
  );
};

export default DocPagesEdit;



// import { Button, CardContent, Grid, TextField, Typography, Divider, Autocomplete, Modal, Box, Select, MenuItem } from '@mui/material';
// import ArrowBackSharpIcon from '@mui/icons-material/ArrowBackSharp';
// import React, { useState, useEffect } from 'react'
// import axios from 'axios';
// import { Navigate, useLocation, useNavigate } from 'react-router-dom';
// import HOST_URL from '../../../utils/Url';
// import { useTranslation } from "react-i18next";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import nopdf from '../../../assets/images/nopdf.png'

// const style = {
//     position: "absolute" as "absolute",
//     top: "50%",
//     left: "50%",
//     transform: "translate(-50%, -50%)",
//     width: "180vh",
//     height: "85vh",
//     bgcolor: "#f5f5f5",
//     border: "1px solid #000",
//     boxShadow: 24,
//     p: 4,
//     borderRadius: 10,
// };


// type Props = {};

// const DocPagesEdit = (props: Props) => {

//     const location = useLocation();
//     console.log('location', location.state)


//     const [PdfOption, setPdfOption] = useState<any>([{ value: "-1", label: "SelectPdf" }]);

//     const [Option, setOption] = useState<any>([{ value: "-1", label: "SelectChildPdf" }]);





//     useEffect(() => {
//         getPdf();
//         getChiPdf();


//     }, [])

//     const getPdf = () => {
//         const collectData = {
//             fileTypeId: -1,
//         };
//         axios
//             .post(HOST_URL.HOST_URL2 + `FileType/GetFileType`, collectData)
//             .then((res) => {
//                 const arr = res.data.data.map((item: any) => ({
//                     label: item.fileTypeName,
//                     value: item.fileTypeId
//                 }));
//                 setPdfOption(arr);
//             })

//     };

//     const getChiPdf = () => {
//         const collectData = {
//             fileTypeId: -1,
//         };
//         axios
//             .post(HOST_URL.HOST_URL2 + `FileType/GetFileType`, collectData)
//             .then((res) => {
//                 const arr = res.data.data.map((item: any) => ({
//                     label: item.fileTypeName,
//                     value: item.fileTypeId
//                 }));
//                 setOption(arr);
//             })

//     };



//     let navigate = useNavigate();
//     const { t } = useTranslation();

//     const back = useNavigate();

//     const requiredFields = ['fileName'];

//     const validationSchema = Yup.object({
//         fileName: Yup.string().test(
//             'required',

//             function (value: any) {
//                 return value && value.trim() !== '';
//             }
//         ),
//     });

//     const formik = useFormik({
//         initialValues: {
//            // dPgid: location.state.dPgid,
//             fileName: location.state.fileName,
//             pdFid: location.state.pdFid,
//             pgNF: location.state.pgNF,
//             pgNU: location.state.pgNU,
//             comments: location.state.comments,
//             createdate: location.state.createdate,
//             chiPDFid: location.state.chiPDFid,
//             phySNo: location.state.phySNo,
//             phyIndex: location.state.phyIndex,
//             relOfficer: location.state.relOfficer,
//             createdateNew: location.state.createdateNew,
//             user_Id: location.state.user_Id,
//             userId: location.state.userId,
//         },
//         validationSchema: validationSchema,
//         onSubmit: async (values) => {

//             const response = await axios.post(
//                 HOST_URL.HOST_URL + `DocFPages/AddUpdateDocFPages`,
//                 values
//             );
//             try {
//                 alert(response.data.mesg);
//                 navigate('/DocManagement/DocPages');
//             } catch (error) {
//                 alert(response.data.mesg);
//             }
//         },
//     });


//     return (
//         <div>
//             <div
//                 style={{
//                     padding: "-5px 5px",
//                     backgroundColor: "#ffffff",
//                     borderRadius: "5px",
//                     marginTop: "5px",
//                     border: ".5px solid #FF7722",
//                 }}
//             >
//                 <CardContent>
//                     <Typography
//                         variant="h5"
//                         textAlign="center"
//                         style={{ fontSize: "18px", fontWeight: 500 }}
//                     >
//                         Edit Doc Pages
//                     </Typography>

//                     <Grid item sm={4} xs={12}>
//                         <Typography style={{ marginTop: "-75px" }}>
//                             <Button
//                                 type="submit"
//                                 onClick={() => back(-1)}
//                                 variant="contained"
//                                 style={{
//                                     marginBottom: 15,
//                                     marginTop: "45px",
//                                     backgroundColor: "blue",
//                                     width: 20,
//                                 }}
//                             >
//                                 <ArrowBackSharpIcon />
//                             </Button>
//                         </Typography>
//                     </Grid>
//                     <Divider />
//                     <br />
//                     <form onSubmit={formik.handleSubmit}>
//                         <Grid item xs={12} container spacing={2}>
//                             <Grid md={4} item>
//                                 <TextField
//                                     label={
//                                         <span>
//                                             file Name{requiredFields.includes('fileName') && (
//                                                 <span style={{ color: formik.values.fileName ? 'green' : 'red' }}>*</span>
//                                             )}
//                                         </span>
//                                     }
//                                     value={formik.values.fileName}
//                                     placeholder="File Name"
//                                     size="small"
//                                     fullWidth
//                                     name="fileName"
//                                     id="fileName"
//                                     style={{ backgroundColor: "white" }}
//                                     onChange={formik.handleChange}
//                                     onBlur={formik.handleBlur}
//                                 />
//                                 {formik.touched.fileName && formik.errors.fileName ? (
//                                     <div style={{ color: "red", margin: "5px" }}>{String(formik.errors.fileName)}</div>
//                                 ) : null}
//                             </Grid>

//                             <Grid md={4} item>
//                                 <TextField
//                                     label="page No. From"
//                                     value={formik.values.pgNF}
//                                     placeholder="Page No. From"
//                                     size="small"
//                                     fullWidth
//                                     name="pgNF"
//                                     id="pgNF"
//                                     style={{ backgroundColor: "white" }}
//                                     onChange={formik.handleChange}
//                                     onBlur={formik.handleBlur}
//                                 />
//                             </Grid>

//                             <Grid md={4} item>
//                                 <TextField
//                                     label="page No. Upto"
//                                     value={formik.values.pgNU}
//                                     placeholder="Page No. Upto"
//                                     size="small"
//                                     fullWidth
//                                     name="pgNU"
//                                     id="pgNU"
//                                     style={{ backgroundColor: "white" }}
//                                     onChange={formik.handleChange}
//                                     onBlur={formik.handleBlur}
//                                 />
//                             </Grid>


//                             <Grid md={4} item>
//                                 <TextField
//                                     label="Comments"
//                                     value={formik.values.comments}
//                                     name="comments"
//                                     id="comments"
//                                     placeholder="Comments"
//                                     size="small"
//                                     fullWidth
//                                     style={{ backgroundColor: "white" }}
//                                     onChange={formik.handleChange}
//                                     onBlur={formik.handleBlur}
//                                 />
//                             </Grid>

//                             <Grid md={4} item>
//                                 <TextField
//                                     label="Created Date"
//                                     value={formik.values.createdate}
//                                     placeholder="Created Date"
//                                     size="small"
//                                     InputLabelProps={{ shrink: true }}
//                                     fullWidth
//                                     name="createdate"
//                                     id="createdate"
//                                     type="date"
//                                     style={{ backgroundColor: "white" }}
//                                     onChange={formik.handleChange}
//                                     onBlur={formik.handleBlur}
//                                 />
//                             </Grid>




//                             <Grid md={4} item>
//                                 <TextField
//                                     label="Created Date New"
//                                     value={formik.values.createdateNew}
//                                     placeholder="Created  Date New"
//                                     size="small"
//                                     InputLabelProps={{ shrink: true }}
//                                     fullWidth
//                                     name="createdateNew"
//                                     id="createdateNew"
//                                     type="date"
//                                     style={{ backgroundColor: "white" }}
//                                     onChange={formik.handleChange}
//                                     onBlur={formik.handleBlur}
//                                 />
//                             </Grid>

//                             <Grid md={4} item>
//                                 <TextField
//                                     label="Physical Serial No"
//                                     value={formik.values.phySNo}
//                                     name="phySNo"
//                                     id="phySNo"
//                                     placeholder="Physical Serial No."
//                                     size="small"
//                                     fullWidth
//                                     style={{ backgroundColor: "white" }}
//                                     onChange={formik.handleChange}
//                                     onBlur={formik.handleBlur}
//                                 />
//                             </Grid>

//                             <Grid md={4} item>
//                                 <TextField
//                                     label="Physical Index"
//                                     value={formik.values.phyIndex}
//                                     name="phyIndex"
//                                     id="phyIndex"
//                                     placeholder="Physical Index"
//                                     size="small"
//                                     fullWidth
//                                     style={{ backgroundColor: "white" }}
//                                     onChange={formik.handleChange}
//                                     onBlur={formik.handleBlur}
//                                 />
//                             </Grid>

//                             <Grid md={4} item>
//                                 <TextField
//                                     label="Related Officer"
//                                     value={formik.values.relOfficer}
//                                     name="relOfficer"
//                                     id="relOfficer"
//                                     placeholder="relOfficer"
//                                     size="small"
//                                     fullWidth
//                                     style={{ backgroundColor: "white" }}
//                                     onChange={formik.handleChange}
//                                     onBlur={formik.handleBlur}
//                                 />
//                             </Grid>


//                             <Grid item lg={4} xs={12}>
//                                 <Autocomplete
//                                     disablePortal
//                                     id="combo-box-demo"
//                                     options={PdfOption}
//                                     value={
//                                         PdfOption.find(
//                                             (option:any) => option.value === formik.values.pdFid
//                                         ) || null
//                                     }
//                                     fullWidth
//                                     size="small"
//                                     onChange={(event, newValue: any) => {
//                                         console.log(newValue?.value);

//                                         formik.setFieldValue("pdFid", newValue?.value);

//                                         formik.setFieldTouched("pdFid", true);
//                                         formik.setFieldTouched("pdFid", false);
//                                     }}
//                                     renderInput={(params) => (
//                                         <TextField {...params} label={
//                                             <span>
//                                                 Select Pdf {""}
//                                                 {requiredFields.includes('pdFid') && (
//                                                     <span style={{ color: formik.values.pdFid ? 'green' : 'red' }}>*</span>
//                                                 )}
//                                             </span>
//                                         } />
//                                     )}
//                                 />

//                                 {formik.touched.pdFid && formik.errors.pdFid ? (
//                                     <div style={{ color: "red", margin: "5px" }}>
//                                         {String(formik.errors.pdFid)}
//                                     </div>
//                                 ) : null}
//                             </Grid>

//                             <Grid item lg={4} xs={12}>
//                                 <Autocomplete
//                                     disablePortal
//                                     id="combo-box-demo"
//                                     options={Option}
//                                     value={
//                                         Option.find(
//                                             (option:any) => option.value === formik.values.chiPDFid
//                                         ) || null
//                                     }
//                                     fullWidth
//                                     size="small"
//                                     onChange={(event, newValue: any) => {
//                                         console.log(newValue?.value);

//                                         formik.setFieldValue("chiPDFid", newValue?.value);

//                                         formik.setFieldTouched("chiPDFid", true);
//                                         formik.setFieldTouched("chiPDFid", false);
//                                     }}
//                                     renderInput={(params) => (
//                                         <TextField {...params} label={
//                                             <span>
//                                                 Select Child Pdf {""}
//                                                 {requiredFields.includes('chiPDFid') && (
//                                                     <span style={{ color: formik.values.chiPDFid ? 'green' : 'red' }}>*</span>
//                                                 )}
//                                             </span>
//                                         } />
//                                     )}
//                                 />

//                                 {formik.touched.chiPDFid && formik.errors.chiPDFid ? (
//                                     <div style={{ color: "red", margin: "5px" }}>
//                                         {String(formik.errors.chiPDFid)}
//                                     </div>
//                                 ) : null}
//                             </Grid>




//                             <Grid item xs={12} spacing={2} style={{ display: 'flex', justifyContent: 'center' }}>
//                                 <Grid xs={6} style={{ margin: '6px' }}>
//                                     <Button
//                                         type="submit"
//                                         fullWidth
//                                         style={{
//                                             backgroundColor: "#059669",
//                                             color: "white",
//                                             marginTop: "10px",
//                                         }}
//                                     >
//                                         {t("text.save")}
//                                     </Button>
//                                 </Grid>

//                                 <Grid xs={6} style={{ margin: '6px' }}>
//                                     <Button
//                                         type="reset"
//                                         fullWidth
//                                         style={{
//                                             backgroundColor: "#F43F5E",
//                                             color: "white",
//                                             marginTop: "10px",
//                                         }}
//                                         onClick={(e) => formik.resetForm()}
//                                     >
//                                         {t("text.reset")}
//                                     </Button>
//                                 </Grid>
//                             </Grid>
//                         </Grid>
//                         {/* </Card> */}
//                     </form>
//                 </CardContent>
//             </div>
//         </div>
//     );
// };

// export default DocPagesEdit;
